import { render, staticRenderFns } from "./MadeAPurchase.vue?vue&type=template&id=4b08b9f6&scoped=true&"
import script from "./MadeAPurchase.vue?vue&type=script&lang=js&"
export * from "./MadeAPurchase.vue?vue&type=script&lang=js&"
import style0 from "./MadeAPurchase.vue?vue&type=style&index=0&id=4b08b9f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b08b9f6",
  null
  
)

export default component.exports